// Helpers to build product query payloads
export function buildProductQuery({ q = '', filters = {}, page = 1, limit = 20 } = {}) {
  const params = { q, page, limit };
  // flatten filters: filters is an object like { category: ['Bebidas'], status: ['ativo'] }
  Object.keys(filters || {}).forEach(key => {
    const val = filters[key];
    if (Array.isArray(val)) {
      if (val.length) params[key] = val.join(',');
      // skip empty arrays entirely
    } else if (val !== undefined && val !== null && val !== '') {
      params[key] = val;
    }
  });
  return params;
}

export function mapProductFromApi(item = {}) {
  // normalize fields used by UI
  return {
    id: item.id || item._id || item.codigo || null,
    title: item.title || item.nome || item.titulo || 'Produto sem nome',
    subtitle: item.subtitle || item.descricao_curta || item.description || '',
    category: item.category || item.categoria || null,
    image: item.image || item.imagem || (item.images && item.images[0]) || null,
    status: item.status || 'ativo',
  };
}

export default { buildProductQuery, mapProductFromApi };
